<template>
  <COProfiles class="profiles-in-steper" :preselected-filters="{
    status: ['active'],
  }" show-select :show-actions="false" :hide-unrelated="true" @selected="enterSelect"></COProfiles>
</template>

<script>
  import {mapActions, mapMutations} from 'vuex'
  import COProfiles from "@/components/pages/affiliates/profiles/COProfiles";

  export default {
    data() {
      return {
        table: {
          selectedAffiliates: [],
        },
      }
    },
    components: {
      COProfiles
    },
    methods: {
      ...mapMutations('affiliates', ['saveMultiplySelectAffiliates']),
      enterSelect(values) {
        this.table.selectedAffiliates.length = 0
        let formatAff = values.map(i => (i.id)).join(",");
        if(formatAff) {
          this.table.selectedAffiliates.push(formatAff)
          this.saveMultiplySelectAffiliates(formatAff)
          return this.$emit('activeButton', true)
        } else {
          this.$emit('activeButton', false)
        }
      }
    },
  }
</script>

<style scoped lang="sass">
  .profiles-in-steper
    margin-top: -15px
</style>
